import { render, staticRenderFns } from "./CanceledWaiterListTab.vue?vue&type=template&id=6add3856&scoped=true&lang=pug"
import script from "./CanceledWaiterListTab.vue?vue&type=script&lang=ts"
export * from "./CanceledWaiterListTab.vue?vue&type=script&lang=ts"
import style0 from "./CanceledWaiterListTab.vue?vue&type=style&index=0&id=6add3856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6add3856",
  null
  
)

export default component.exports